@if (view === 'dialog') {
  <ejs-dialog target=".dialogs" class="simple-dialog" [visible]='visible'
    [animationSettings]='dialogService.getAnimationSettings()'
    [resizeHandles]='dialogService.getResizeHandleDirection()' [position]='dialogService.getPosition()' [isModal]="true"
    [allowDragging]="false" [width]="'40%'" [height]="'60vh'" [zIndex]="999" [showCloseIcon]="!totalProgress"
    (close)="close()">
    <ng-template #header>
      <div class="d-flex align-items-center justify-content-center">
        <app-headline [title]="title" [type]="'h5'" [class]="'text-primary'"></app-headline>
        <app-tooltip [icon]="'help'" [iconClass]="'fs-5 p-1'" [text]="tooltip" [width]="'300px'" [height]="'100px'"
        [cssClass]="'helpTooltip p-2'" [opensOn]="'Click'"></app-tooltip>
      </div>
    </ng-template>
    <ng-template #content>
      <div class="d-flex flex-column h-100 p-3">
        <div class="d-flex justify-content-between align-items-center mb-1">
          <span class="text-secondary fw-bold">
            <!-- //TODO this label needs to be dynamic attribute @Input because sometimes you cannot upload a video, but only an image and UPLOADIMAGE has a image/video translation-->
            <app-form-label [type]="'content'"
            [label]="type=== 'image' ? ('UPLOADIMAGEONLY' | translate) : type === 'media' ? ('UPLOADIMAGE' | translate) : ('UPLOADFILES' | translate)"></app-form-label>
          </span>
          @if (!totalProgress) {
            <div class="dropdown">
              <button type="button" class="btn btn-link p-0 text-muted" data-bs-toggle="dropdown" aria-expanded="false"
                [attr.aria-label]="('SRMOREOPTIONS' | translate)">
                <app-icon-badge [style]="'notification'" [icon]="'more_horiz'"
                [screenReaderText]="'SRMOREOPTIONS' | translate"></app-icon-badge>
              </button>
              @if (!disabled) {
                <ul class="dropdown-menu dropdown-menu-end">
                  <li><app-link (click)="fileInput.click()" [title]="('DOCUMENTSUPLOADIMAGE' | translate)"
                  [style]="'dropdown'">{{ ('DOCUMENTSUPLOADIMAGE' | translate) }}</app-link></li>
                  <li><app-link (click)="documentsCommanderDialog = true" [title]="('DOCUMENTSMYFILES' | translate)"
                  [style]="'dropdown'">{{ ('DOCUMENTSMYFILES' | translate) }}</app-link></li>
                </ul>
              }
            </div>
          }
        </div>
        @if (description) {
          <div class="mb-2">
            <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">{{ description }}</app-content>
          </div>
        }
        <div class='fileUploadArea mb-3' (drop)="fileDrop($event)" (dragover)="dragOver($event)"
          (dragleave)="onDragLeave()">
          <div class="card" [class.dragging-over]="isDraggingOver">
            <div class="card-body">
              <div class="d-flex mx-auto justify-content-center m-3">
                <div class="d-flex flex-column">
                  <div class="d-flex align-items-center">
                    <app-icon-badge [style]="'documents'"></app-icon-badge>
                    <app-content [fontSize]="'fs-6'" [fontColor]="'text-secondary'" [class]="'upload-text'">{{
                    ('DOCUMENTSDRAGANDDROP' | translate) }}</app-content>
                    @if (!disabled) {
                      <app-form-button (click)="fileInput.click()" [style]="'btn'"
                        [cssClass]="'upload-choose-file btn-link text-secondary fw-bold fs-normal mx-1 px-0 py-1'"
                      [text]="('DOCUMENTSCHOOSEFILE' | translate)"></app-form-button>
                    }
                    <input type="file" (change)="fileSelect($event)" [multiple]="multiple" hidden #fileInput />
                  </div>
                  @if (totalProgress) {
                    <app-progress [value]="totalProgress"></app-progress>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="custom-scrollbar">
          <div class="d-flex flex-wrap gap-2 uploadedFilesContainer">
            @for (file of uploadingFiles; track file) {
              <app-item-documents-preview-uploading [file]="file"></app-item-documents-preview-uploading>
            }
            @for (file of files; track file; let i = $index) {
              <app-item-documents-preview-selected [file]="file" [(files)]="files"
              [position]="i" (filesChange)="update()"></app-item-documents-preview-selected>
            }
          </div>
        </div>
      </div>
    </ng-template>
    <ng-template #footerTemplate>
      <div class="d-flex align-items-center justify-content-center p-2">
        <app-form-button [text]="'SAVE' | translate" (click)="save()" 
          [disabled]="!!totalProgress || (requireFiles && (!files || files.length === 0))"
        [cssClass]="'e-primary mx-auto w-50'"></app-form-button>
      </div>
    </ng-template>
  </ejs-dialog>
}


@if (view === 'component') {
  <div class="d-flex flex-column h-100">
    <div class="d-flex justify-content-between align-items-center mb-1">
      <span class="text-secondary fw-bold">
        <app-form-label [type]="'content'"
        [label]="type=== 'image' ? ('UPLOADIMAGEONLY' | translate) : type === 'media' ? ('UPLOADIMAGE' | translate) : ('UPLOADFILES' | translate)"></app-form-label>
      </span>
      @if (!totalProgress) {
        <div class="dropdown">
          <button type="button" class="btn btn-link p-0 text-muted" data-bs-toggle="dropdown" aria-expanded="false"
            [attr.aria-label]="('SRMOREOPTIONS' | translate)">
            <app-icon-badge [style]="'notification'" [icon]="'more_horiz'"
            [screenReaderText]="'SRMOREOPTIONS' | translate"></app-icon-badge>
          </button>
          @if (!disabled) {
            <ul class="dropdown-menu dropdown-menu-end">
              <li><app-link (click)="fileInput.click()" [title]="('DOCUMENTSUPLOADIMAGE' | translate)"
              [style]="'dropdown'">{{ ('DOCUMENTSUPLOADIMAGE' | translate) }}</app-link></li>
              <li><app-link (click)="documentsCommanderDialog = true" [title]="('DOCUMENTSMYFILES' | translate)"
              [style]="'dropdown'">{{ ('DOCUMENTSMYFILES' | translate) }}</app-link></li>
            </ul>
          }
        </div>
      }
    </div>
    @if (description) {
      <div class="mb-2">
        <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">{{ description }}</app-content>
      </div>
    }
    <div class='fileUploadArea mb-3' (drop)="fileDrop($event)" (dragover)="dragOver($event)"
      (dragleave)="onDragLeave()">
      <div class="card" [class.brd-danger]="hasError" [class.dragging-over]="isDraggingOver">
        <div class="card-body">
          <div class="d-flex mx-auto justify-content-center m-3">
            <div class="d-flex flex-column">
              <div class="d-flex align-items-center">
                <app-icon-badge [style]="'documents'"></app-icon-badge>
                <app-content [fontSize]="'fs-6'" [fontColor]="'text-secondary'" [class]="'upload-text'">{{
                ('DOCUMENTSDRAGANDDROP' | translate) }}</app-content>
                @if (!disabled) {
                  <app-form-button (click)="fileInput.click()" [style]="'btn'"
                    [cssClass]="'upload-choose-file btn-link text-secondary fw-bold fs-normal mx-1 px-0 py-1'"
                  [text]="('DOCUMENTSCHOOSEFILE' | translate)"></app-form-button>
                }
                <input type="file" (change)="fileSelect($event)" [multiple]="multiple" hidden #fileInput />
              </div>
              @if (totalProgress) {
                <app-progress [value]="totalProgress"></app-progress>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
    @if(!hideUploadedContent) {
      <div class="custom-scrollbar">
        <div class="d-flex flex-wrap gap-2 uploadedFilesContainer">
          @for (file of uploadingFiles; track $index) {
            <app-item-documents-preview-uploading [file]="file"></app-item-documents-preview-uploading>
          }
          @for (file of files; track $index) {
            <app-item-documents-preview-selected [file]="file" [(files)]="files"
            [position]="$index" (filesChange)="update()"></app-item-documents-preview-selected>
          }
        </div>
      </div>
    }
  </div>
}

@if (documentsCommanderDialog) {
  <app-dialog-documents-commander [(visible)]="documentsCommanderDialog" [files]="files"
  (filesChange)="update()" [type]="type"></app-dialog-documents-commander>
}
